var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSleet01 = function SvgSleet01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sleet-01_svg2__a",
    x1: 0.66,
    x2: 161.96,
    y1: 176.66,
    y2: 15.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sleet-01_svg2__a",
    id: "sleet-01_svg2__b",
    x1: 48.26,
    x2: 209.56,
    y1: 224.26,
    y2: 62.96
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sleet-01_svg2__a",
    id: "sleet-01_svg2__c",
    x1: 8.91,
    x2: 170.22,
    y1: 184.91,
    y2: 23.61
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sleet-01_svg2__a",
    id: "sleet-01_svg2__d",
    x1: 56.59,
    x2: 217.9,
    y1: 232.59,
    y2: 71.29
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sleet-01_svg2__a",
    id: "sleet-01_svg2__e",
    x1: 19.34,
    x2: 180.64,
    y1: 195.34,
    y2: 34.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sleet-01_svg2__a",
    id: "sleet-01_svg2__f",
    x1: -7.65,
    x2: 153.65,
    y1: 168.35,
    y2: 7.05
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sleet-01_svg2__a",
    id: "sleet-01_svg2__g",
    x1: 7.6,
    x2: 168.91,
    y1: 183.6,
    y2: 22.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sleet-01_svg2__a",
    id: "sleet-01_svg2__h",
    x1: 38.08,
    x2: 199.38,
    y1: 214.08,
    y2: 52.78
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sleet-01_svg2__a",
    id: "sleet-01_svg2__i",
    x1: 33.73,
    x2: 195.03,
    y1: 209.73,
    y2: 48.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sleet-01_svg2__a",
    id: "sleet-01_svg2__j",
    x1: 65.23,
    x2: 226.54,
    y1: 241.23,
    y2: 79.93
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sleet-01_svg2__a",
    id: "sleet-01_svg2__k",
    x1: 61.34,
    x2: 222.64,
    y1: 237.34,
    y2: 76.04
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M151.81 28.61c-3.18 0-6.44.43-9.87 1.31C133.54 11.64 115.6 0 95.35 0 72.91 0 53.24 14.36 46.4 35.73c-.62 1.93.44 4 2.38 4.62s4-.44 4.62-2.38C59.26 19.66 76.12 7.35 95.35 7.35c17.09 0 32.25 9.68 39.58 24.95-5.04 2.31-8.53 5.71-10.67 8.43-1.26 1.59-.98 3.9.61 5.16a3.674 3.674 0 0 0 5.16-.61c1.99-2.52 5.48-5.85 10.81-7.38.02 0 .1-.03.13-.04 3.92-1.28 7.46-1.9 10.85-1.9 19.41 0 35.21 15.79 35.21 35.21s-15.79 35.21-35.21 35.21H39.5c-14.62 0-26.52-11.89-26.52-26.52s11.9-26.52 26.52-26.52c2.16 0 4.42.35 7.1 1.1 3.52 1.06 6.78 2.96 9.19 5.36.72.71 1.65 1.07 2.59 1.07s1.89-.36 2.61-1.08a3.68 3.68 0 0 0-.02-5.2c-3.26-3.24-7.62-5.8-12.28-7.2h-.04c-.01 0-.02-.01-.03-.02-3.37-.94-6.26-1.39-9.12-1.39-18.68 0-33.87 15.19-33.87 33.87s15.19 33.86 33.87 33.86h112.3c23.47 0 42.56-19.09 42.56-42.56s-19.09-42.56-42.56-42.56",
    style: {
      fill: "url(#sleet-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.5 122.26c-7.06 0-12.77 5.71-12.77 12.77s5.71 12.77 12.77 12.77 12.76-5.71 12.76-12.77-5.71-12.76-12.76-12.77m0 18.99a6.23 6.23 0 0 1 0-12.46 6.23 6.23 0 0 1 0 12.46",
    style: {
      fill: "url(#sleet-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.11 153.95c-7.05 0-12.76 5.72-12.76 12.77s5.71 12.77 12.77 12.76c7.06 0 12.76-5.71 12.76-12.77-.01-7.04-5.72-12.74-12.76-12.76m0 18.99c-3.44 0-6.23-2.79-6.23-6.23s2.78-6.23 6.22-6.23 6.23 2.78 6.24 6.22c0 3.44-2.79 6.23-6.23 6.24",
    style: {
      fill: "url(#sleet-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.6 169.18c-8.52 0-15.41 6.89-15.41 15.41S96.09 200 104.6 200s15.41-6.89 15.41-15.41-6.9-15.4-15.41-15.41m0 24.29c-4.9 0-8.88-3.97-8.88-8.87s3.98-8.87 8.88-8.87 8.87 3.97 8.87 8.87-3.98 8.87-8.87 8.87",
    style: {
      fill: "url(#sleet-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3 122.26c-5.59 0-10.12 4.52-10.12 10.12s4.53 10.11 10.12 10.12c5.59 0 10.13-4.52 10.13-10.12s-4.53-10.12-10.13-10.12m0 13.71c-1.98 0-3.59-1.6-3.59-3.59s1.61-3.59 3.59-3.59 3.59 1.61 3.59 3.59-1.61 3.59-3.59 3.59",
    style: {
      fill: "url(#sleet-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.11 144.93c-1.84 0-3.32-1.49-3.32-3.32v-16.03c0-1.84 1.49-3.32 3.32-3.32s3.32 1.49 3.32 3.32v16.03c0 1.84-1.49 3.32-3.32 3.32",
    style: {
      fill: "url(#sleet-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.71 150.74c-1.84 0-3.32-1.49-3.32-3.32v-21.84c0-1.84 1.49-3.32 3.32-3.32s3.32 1.49 3.32 3.32v21.84c0 1.84-1.49 3.32-3.32 3.32",
    style: {
      fill: "url(#sleet-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.9 160.94c-1.84 0-3.32-1.49-3.32-3.32v-30.7c0-1.84 1.49-3.32 3.32-3.32s3.32 1.49 3.32 3.32v30.7c0 1.84-1.49 3.32-3.32 3.32",
    style: {
      fill: "url(#sleet-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.71 190.96c-1.84 0-3.32-1.49-3.32-3.32v-33.77c0-1.84 1.49-3.32 3.32-3.32s3.32 1.49 3.32 3.32v33.77c0 1.84-1.49 3.32-3.32 3.32",
    style: {
      fill: "url(#sleet-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.8 183.91c-1.84 0-3.32-1.49-3.32-3.32v-21.84c0-1.84 1.49-3.32 3.32-3.32s3.32 1.49 3.32 3.32v21.84c0 1.84-1.49 3.32-3.32 3.32",
    style: {
      fill: "url(#sleet-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.09 144.93c-1.84 0-3.32-1.49-3.32-3.32v-16.03c0-1.84 1.49-3.32 3.32-3.32s3.32 1.49 3.32 3.32v16.03c0 1.84-1.49 3.32-3.32 3.32",
    style: {
      fill: "url(#sleet-01_svg2__k)"
    }
  }));
};
export default SvgSleet01;